import axios from 'axios'

const ENDPOINT = 'directory'

export default {
  // delete: async (sitePath, id) => {
  //   const url = `${sitePath}/${ENDPOINT}/${id}/`
  //   const response = await axios.delete(url)

  //   return response.data
  // },

  get: async (sitePath, id) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    return await axios.get(url)
  },

  list: async (sitePath) => {
    const url = `${sitePath}/${ENDPOINT}`
    return await axios.get(url)
  },

  post: async (sitePath, data) => {
    const url = `${sitePath}/${ENDPOINT}/`
    return await axios.post(url, data)
  },

  put: async (sitePath, id, data) => {
    const url = `${sitePath}/${ENDPOINT}/${id}/`
    return await axios.put(url, data)
  },

  // put: async (sitePath, id, data) => {
  //   const url = `${sitePath}/${ENDPOINT}/${id}/`
  //   return await axios.put(url, data)
  // },
}
